<script>
// 加载中
import InnerLoading from "@/components/spinner/spinner.vue";
// 动态表单模版
import Temp from '@/components/technician/temp/index';
import {getLocalItem} from "@/untils/common";
import { ClientId } from "@/lib/cli"
import {Dialog} from "vant";
import {
  updateBranchInfo,
  inspectionMobilePageList,
  inspectionReceiptor,
  processTaskHistorical,
  processRemove
} from "@/lib/request";
import wx from "weixin-js-sdk";
export default {
  name: 'techListInspection',
  data() {
    return {
      innerLoading: false,
      siteId: '',
      showSiteId: false,
      activeTab: '0',
      content: '',
      imageLocationFlag: false,
      siteIdItem: {},
      storefrontPhoto: '',
      //------
      fileVideoUrl: '/api/resource/oss/upload',//接口前缀加api
      headers: {
        'isEncrypt': true,
        'Authorization': 'Bearer ' + getLocalItem('access_token'),
        'clientid': ClientId,
      },
      loading: false,
      imgFlag2: false,
      //是否显示进度条
      imgUploadPercent2: 0,
      //进度条的进度，
      isShowUploadImg2: false,
      //显示上传按钮
      imgForm2: {
        showVideoPath: "",  //回显的变量
      },
      // longitude:'',//108.390062 本地调试使用
      // latitude:'',//22.818713 本地调试使用

      longitude: '',//116.0484634399414,
      latitude: '',//29.98253631591797,
      // ---
      // 动态表单模版
      returnObj: {},
      formDefine: {},
      flowNameObj: {},
      formFields: [],
      siteItem: {
        // "branchId": '',
      },
      flagTemp: false,
      // 列表数据
      page1: 1,//当前页
      size1: 20,//每页条数
      totals1: 0,//总条数
      totalPages1: 0,//总页数
      finished1: true,
      loading1: false,
      finishedMsgTxt: '没有更多了',
      inList: [],
      // 流程历史信息
      historyList: []
    }
  },
  components: {
    InnerLoading,
    Temp,
  },
  watch: {
    // 监控参数变化更新游戏列表接口数据
    searchParams: function (val, oldVal) {
      if (val.siteid === '' || val.siteid.length === 8) {
        this.getListData();
      }
      if (val.state !== oldVal.state) {
        this.page1 = 1;
      }
    },
  },
  computed: {
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        siteid: this.siteId,
        pageSize: this.size1,//每页数量
        pageNum: this.page1,//当前页码
        // openId:this.user_openid,//
        // orderByColumn:'createTime',
        // isAsc:'asc',
        state: this.activeTab//积分类型
      };
    },
  },
  created() {
    // 当前任务列表数据
    this.getListData();
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        if (this.page1 < this.totalPages1) {
          this.page1 = this.page1 + 1;
        }
      }, 1000);
    },
    // 当前任务列表数据
    getListData() {
      this.loading1 = true;
      this.finished1 = false;
      if (this.searchParams.pageNum === 1) {
        this.inList = [];
      }
      if (this.searchParams.siteid) {
        this.inList = [];
      }
      inspectionMobilePageList(this.searchParams).then((res) => {
        if (res) {
          if (res.data) {
            this.loading1 = false;
            if (res.data.code === 200) {
              // this.inList = res.data.rows;
              this.totals1 = res.data.total;
              this.totalPages1 = Math.ceil(res.data.total / this.size1);
              if (res.data.rows == null || res.data.rows.length === 0) {
                this.finished1 = true;
                this.inList = [];
                return false;
              } else {
                if (this.page1 > 1) {
                  this.inList = this.inList.concat(res.data.rows);
                } else {
                  this.inList = res.data.rows;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 查看网点
    getQuerySiteIdInfo(siteId) {
      if (siteId) {
        this.$router.push({path: '/techSiteId', query: {'siteId': siteId}});
      } else {
        this.$toast('无网点编号');
      }
    },
    // 流程表单提交接口
    getTempReturn(data) {
      console.log(data)
      this.formFields = [];
      this.returnObj = {};
      this.formDefine = {};
      this.flagTemp = false;
      this.page1 = 1;
      this.getListData();
    },
    // 查看详情
    getHistoryInfo(id) {
      if (!id) return;
      this.content = 'close';
      this.formFields = [];
      this.returnObj = {};
      this.formDefine = {};
      processTaskHistorical({
        processInstanceId: id,
        handler: false
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if (res.data.data.historicActivityInstances && res.data.data.historicActivityInstances.length > 0) {
                res.data.data.historicActivityInstances.map((v) => {
                  if (v.formInfo.fields) {
                    v.formInfo.fields.map((i) => {
                      if (i.params.customDesign.type === 'fileupload') {
                        i.files = i.value ? i.value.split(',') : [];
                      } else if (i.params.customDesign.type === 'rate') {
                        i.value = parseInt(i.value) / 2;
                      }
                    })
                  }
                });
                this.flagTemp = true;
                this.historyList = res.data.data.historicActivityInstances;
              } else {
                this.historyList = [];
                this.$toast('历史数据为空！');
                return false;
              }
            } else {
              this.$toast.fail(res.data.msg);
              return false;
            }
          }
        }
      });
    },
    // 新建流程未提交的流程，关闭页面执行删除操作
    getApiDel(item, type) {
      if (!item.processInstanceId) {
        this.$toast('没有流程id（processInstanceId）！')
        return false;
      }
      console.log('删除流程', item.processInstanceId)
      processRemove({
        processInstanceId: item.processInstanceId
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if (type) {
                // 去处理按钮，删除流程后，重新新建流程
                this.getCreat(item, type);
              } else {
                // 直接删除流程
                this.getListData();
              }
            } else {
              this.$toast(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    getCancel() {
      this.imageLocationFlag = !this.imageLocationFlag;
      console.log('取消')
    },
    // 去处理
    getActiveItemInfo(item, type) {
      // 讨论的第二版本，先上传门头+定位，判断是否可以巡检后，进入流程 。
      // this.siteIdItem = item;
      // this.imageLocationFlag = true;

      // 正常版本，直接进入流程
      // 处理中的巡检：先删除后新建流程
      if (item.state === '1') {
        this.getApiDel(item, type);
      } else {
        this.getCreat(item, type);
      }
    },
    getCreat(item, type) {
      // 网点处理巡检，代销者以及销售员
      if (type === '1') {
        Dialog({
          title: `提示`,
          message: `确定要通知该网点的代销者以及销售员去处理巡检吗?`,
          confirmButtonText: '确定',
          showCancelButton: true,
          cancelButtonText: '取消',
          theme: 'round-button',
        }).then(() => {
          //确定
          this.getSub(item, type)
        }).catch((error) => {
          // 取消
          console.log('取消', error);
        });
      } else {
        this.getSub(item, type)
      }
    },
    getSub(item, type) {
      if (!item.siteid) {
        return;
      }
      this.siteItem = {
        branchId: item.siteid,
        processDefinitionName: '一般巡检'
      };
      this.content = 'del';
      this.historyList = [];
      this.innerLoading = true;
      inspectionReceiptor({
        id: item.id,
        inspectorstype: type
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              console.log('创建表单', res.data.data)
              this.returnObj = res.data.data.processStartOutput;
              let formDefine = JSON.parse(res.data.data.processStartOutput.formModelJson);
              if (formDefine) {
                this.getListData();
                if (type === '1') {
                  this.innerLoading = false;
                  this.$toast.success('已发送通知给网点的代销者以及销售员巡检！');
                  return false;
                }
                this.formDefine = formDefine;
                if (formDefine.fields.length > 0) {
                  formDefine.fields.map((v) => {
                    v.id_name = '';
                    v.showItem = true;
                    if (v.id.indexOf('Name') !== -1) {
                      v.id_name = 'name'
                    } else if (v.id.indexOf('name') !== -1) {
                      v.id_name = 'name'
                    } else if (v.id.indexOf('phone') !== -1) {
                      v.id_name = 'phone'
                    } else if (v.id.indexOf('identity') !== -1) {
                      v.id_name = 'identity'
                    }
                    if (v.params.customDesign) {
                      if (v.params.customDesign.type === 'fileupload') {
                        v.files = [];
                      } else if (v.params.customDesign.type === 'rate') {
                        v.socre = 0;
                        v.scoreValue = 0;
                        v.scoreValueFlag = true;
                      } else if (v.params.customDesign.type === 'date') {
                        v.dates = '';
                        v.dateValue = '';
                        v.dateValueFlag = true;
                      } else if (v.params.customDesign.type === 'select') {
                        // 复选框
                        if (v.params.customDesign.multiple) {
                          v.checkList = []
                        }
                      }
                    }
                  });
                }
                this.formFields = formDefine.fields;
                this.flagTemp = true;

              } else {
                this.innerLoading = false;
                this.$toast(res.data.data.processStartOutput.errorMessage);
                this.getListData();
                return false;
              }
            } else {
              this.innerLoading = false;
              this.$toast.fail(res.data.msg);
              return false;
            }
            this.innerLoading = false;
          }
        }
      });
    },
    // 定位
    getWechatLocation() {
      let that = this;
      // let url = window.location.href.split('#')[0];
      // if(url) {
      //   // 接口返回appid和签名类的数据
      //   this.$http.weChatScan_preScan({
      //     url:url,
      //   }).then((res) => {
      //     if (res&&res.data) {
      //       // console.log('第二步：验证签名接口返回数据，进入wx.config执行');
      //       wx.config({
      //         debug: false, // 开启调试模式,
      //         appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
      //         timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      //         nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      //         signature: res.data.signature,// 必填，签名，见附录1
      //         jsApiList: [
      //           'getLocation',
      //           // 'chooseImage',
      //           // 'scanQRCode',
      //           // 'getLocalImgData',
      //           // 'openCustomerServiceChat',
      //           // 'updateAppMessageShareData',
      //           // 'updateTimelineShareData', // 需要使用的JSAPI列表
      //           // 'onMenuShareTimeline', // 旧版朋友圈分享（兼容）
      //           // 'onMenuShareAppMessage' // 旧版好友分享（兼容）
      //         ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      //       });
      //       wx.ready(() => {
      //         console.log('ready--------')
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入' gcj02 '
        isHighAccuracy: true,
        success: function (data) {
          console.log(data);
          that.latitude = data.latitude;
          that.longitude = data.longitude;
        },
        fail: err => {
          that.getConfig();
          console.log('wx.getLocation方法 ，失败');
          console.log(err);
          console.log(err.errMsg);
          if (err.errMsg.includes('user deny')) {
            that.$toast = '您拒绝了位置授权，请前往设置开启';
          } else {
            that.$toast = `获取位置失败：${err.errMsg}`;
          }
        }
      });
      //       });
      //       wx.error(error => {
      //         // this.$toast.fail('验证签名失败，无法获得微信分享功能')
      //         console.log('---wx.config---SDK初始化失败------');
      //         console.log(error)
      //         console.log(error.errMsg)
      //         Dialog.alert({
      //           title: '获取地理位置失败',
      //           message: `
      //           <div class="innerDialog">
      //             <div style="text-align: left;">点击刷新按钮，再次操作上传门头照片功能，系统会给您授权地理位置的提示，请您务必选择允许按钮。</div>
      //           </div>`,
      //           confirmButtonText: '刷新',
      //           theme: 'round-button',
      //         }).then(() => {
      //           // 刷新页面
      //           location.reload();
      //         });
      //       });
      //     }else{
      //       that.$toast('请求出错！')
      //     }
      //   });
      // }
    },
    getConfig() {
      let url = window.location.href.split('#')[0];
      if (url) {
        // 接口返回appid和签名类的数据
        this.$http.weChatScan_preScan({
          url: url,//encodeURIComponent(url),
        }).then((res) => {
          if (res) {
            if (res.code && res.code === 200) {
              wx.config({
                debug: false, // 开启调试模式,
                appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: [
                  'getLocation',
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              });
              wx.ready(() => {
                this.getWechatLocation();
              });
              wx.error(error => {
                console.error('---wx.config---SDK初始化失败------');
                console.error(error)
                console.error(error.errMsg)
              });
            }
          }
        });
      }
    },
    // 门 头照
    handleUpdateImgSubmit() {
      console.log(this.siteIdItem)
      console.log(this.longitude);
      console.log(this.latitude);
      let params = {
        "branchId": this.siteIdItem.siteid,
        "storefrontPhoto": this.storefrontPhoto,
        // "storefrontPhotoUrl": this.imgForm2.showVideoPath,//"http://dcom.unlto.com/2025/06/04/14705e599c8a492e9b0bead10ff0cfb3.jpg",
        "longitude": this.longitude,//116.4484634399414,
        "latitude": this.latitude,//39.98253631591797,
      }
      console.log(params)
      if (this.longitude && this.latitude) {
        updateBranchInfo(params).then((res) => {
          if (res) {
            console.log(res)
            if (res.data.code === 200) {
              this.imageLocationFlag = false;
              this.$toast.success(res.data.msg);
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        });
      } else {
        // this.$toast('未获取到您当前地理位置，请前往系统权限改为允许访问定位！')
        // this.getLocation();
      }
    },
    beforeDelete(index) {
      if (index === 2) {
        this.imgForm2 = {}
        this.imgForm2.showVideoPath = ''
      }
    },
    // 上传照片 oss
    beforeUploadImg2(file) {
      // 微信授权 获取地理位置
      this.getWechatLocation();

      if (
          ["image/png", "image/jpg", "image/jpeg",].indexOf(file.type) === -1     //控制格式
      ) {
        this.$toast("请上传正确的图片格式");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 500;   //控制大小  修改50的值即可
      if (!fileSize) {
        this.$toast("图片大小不能超过500MB");
        return false;
      }
      this.isShowUploadImg2 = false;
      this.imgForm2.showVideoPath = URL.createObjectURL(file);
    },
    //进度条
    uploadImgProcess2(event, file, fileList) {    //注意在data中添加对应的变量名
      console.log('门头照', event)
      console.log('门头照', fileList)
      this.imgFlag2 = true;
      this.imgUploadPercent2 = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleImgSuccess2(res, file) {
      console.log('门头照', file)
      this.loading = true;
      this.isShowUploadImg2 = true;
      this.imgFlag2 = false;
      this.imgUploadPercent2 = 0;
      //后台上传数据
      if (res.code === 200) {
        if (res.data) {
          this.loading = false;
          // 门 头照参数
          this.storefrontPhoto = res.data.ossId;
        }
      } else {
        this.$toast(res.msg);
        return false;
      }
    },
  }
}
</script>
<template>
  <div class="tech-content">
    <!--    加载中-->
    <inner-loading v-model="innerLoading"></inner-loading>
    <!--    动态表单模版   -->
    <Temp v-model="flagTemp" :content="content" :variablesObj="{}" :flowNameObj="flowNameObj" :historyList="historyList"
          :siteIdObj="siteItem" :returnObj="returnObj" :formDefine="formDefine" :formFields="formFields"
          @submit="getTempReturn"></Temp>
    <!--    门头照片+获取定位信息-->
    <div class="wrap-diag" v-show="imageLocationFlag">
      <div class="modal-container-diag">
        <div class="modal-title">上传门头照片
          <van-icon name="cross" @click="imageLocationFlag=!imageLocationFlag" class="prefix-right"/>
        </div>
        <div class="group-video">
          <div class="group-video-load">
            <el-upload
                id="upload_Id2"
                class="avatar-uploader"
                :action="fileVideoUrl"
                :headers="headers"
                v-model="imgForm2.showVideoPath"
                accept="image/jpeg, image/jpg, image/png"
                v-bind:on-progress="uploadImgProcess2"
                v-bind:on-success="handleImgSuccess2"
                v-bind:before-upload="beforeUploadImg2"
                v-bind:show-file-list="false"
                capture="camera"
            >
              <div v-if="imgForm2.showVideoPath !== '' && !imgFlag2" v-bind:src="imgForm2.showVideoPath"
                   class="avatar video-avatar" controls="controls">
                <img :src="imgForm2.showVideoPath" alt=""/>
              </div>
              <div class="group-load-item" v-else-if="imgForm2.showVideoPath === '' && !imgFlag2">
                <div class="video-icon-img"><i class="el-icon-camera"></i></div>
                <div class="video-icon-txt">拍照上传</div>
              </div>
              <el-progress v-if="imgFlag2 === true" type="circle" v-bind:percentage="imgUploadPercent2"
                           style="text-align: center;"></el-progress>
            </el-upload>
            <div v-if="imgForm2.showVideoPath !== '' && !imgFlag2" class="aod" @click="beforeDelete(2)">&times;</div>
          </div>
        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" native-type="button"
                      @click="getCancel">取消
          </van-button>
          <van-button round block type="primary" color="#e62d2d" native-type="submit" @click="handleUpdateImgSubmit">
            提交
          </van-button>
        </div>
      </div>
    </div>
    <div class="tabs">
      <van-tabs v-model="activeTab" animated swipeable sticky>
        <van-tab title="待完成" name="0"></van-tab>
        <van-tab title="处理中" name="1"></van-tab>
        <van-tab title="已完成" name="2"></van-tab>
      </van-tabs>
    </div>
    <div class="nav-search">
      <input type="number" v-model="siteId" placeholder="输入8位网点编号自动搜索"/>
      <van-button round block type="primary" class="button" color="#e62d2d" @click="siteId=''">重置</van-button>
    </div>
    <div>
      <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false"
                @load="onLoad">
        <div class="card" v-for="(item,index) in inList" :key="index">
          <div class="card-title">
            {{ item.name }}
            <span class="countdown" v-if="item.state!=='2'">剩余时间: {{ item.days }}天</span>
            <span class="tag-completes" v-else>已完成</span>
          </div>
          <div class="card-info">
            <div class="card-info-item">网点编号：{{ item.siteid }}</div>
            <div class="card-info-item">地区：{{ item.city }}</div>
          </div>
          <div class="card-info">
            <div class="card-info-item">联系人：{{ item.nickName }}</div>
            <div class="card-info-item">联系电话：{{ item.phonenumber }}</div>
          </div>
          <div class="card-footer">
            <div class="card-info">{{ item.state === '2' ? '完成时间' : '创建时间' }}:{{
                item.state === '2' ? item.updateTime : item.startDate
              }}
            </div>
            <div class="card-footer-btn">
              <div class="text-inter">
                <span v-if="item.state==='1'&&item.agentinspection==='1'&&item.inspectorstype==='1'">网点处理中</span>
              </div>
              <div class="btn-inter">
                <span class="btn-ins btn-sec" @click="getQuerySiteIdInfo(item.siteid)">查看网点</span>
                <span class="btn-ins btn-pri" @click="getActiveItemInfo(item,'0')"
                      v-if="item.state==='0'">去处理</span>
                <!--  任务中断，未处理完，待完成状态，点击去处理按钮，先删掉之前的流程，然后再新建一个流程动态表单-->
                <span class="btn-ins btn-pri" @click="getActiveItemInfo(item,'0')"
                      v-if="item.state==='1'&&item.inspectorstype==='0'">去处理</span>
                <span class="btn-ins btn-pri" @click="getActiveItemInfo(item,'1')"
                      v-if="item.state==='0'&&item.agentinspection==='1'">网点处理</span>
                <span class="btn-ins btn-sec" @click="getHistoryInfo(item.processInstanceId)" v-if="item.state==='2'">任务详情</span>
                <!--                <span class="btn-ins btn-sec" @click="getApiDel(item)"-->
                <!--                      v-if="item.state==='1'&&item.processInstanceId!==''">删除</span>-->
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<style scoped lang="scss">
.card-footer {
  display: flex;
  flex-flow: column;
  width: 100%;
}

.card-footer-btn {
  display: flex;
  flex-flow: row;
  width: 100%;
  justify-content: space-between;
  padding-top: 10px;

  .text-inter {
    width: 25%;
    color: #e62d2d;
  }

  .btn-inter {
    text-align: right;
    width: 75%;
    //display: flex;
    //flex-flow: row;
    //flex: 1;
    //justify-content: flex-end;
    .btn-ins {
      display: inline-block;
      font-size: 24px;
      border-radius: 5px;
      border: none;
      text-align: center;
      margin-left: 10px;
      padding: 10px 20px;
    }

    .btn-pri {
      background-color: #e62d2d;
      color: white;
    }

    .btn-sec {
      background-color: #f5f5f5;
      color: #666;
      border: 1px solid #ddd;
    }
  }
}

.tech-content {
  padding-top: 120px;
  box-sizing: border-box;

  .nav-search {
    //background: #25a603;
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;

    input {
      width: 78%;
      outline: none;
      padding: 0 20px;
      box-sizing: border-box;
      border-radius: 5px;
      border: 2px solid #ddd;
      margin-right: 2%;
    }

    .button {
      width: 20%;
      border-radius: 5px;
    }
  }
}

/deep/ .van-sticky--fixed {
  z-index: 9 !important;
}

.wrap-diag {
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.3);

  .modal-container-diag {
    background: white;
    height: auto;
    width: 100vw;
    position: fixed;
    left: 0;
    bottom: 0;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    padding: 20px;

    .prefix-right {
      position: absolute;
      right: 40px;
      top: 40px;
      font-size: 44px;
      color: #8f8f8f;
    }
  }
}

.loading-ing {
  height: 100vh;
  width: 100vw;
  position: relative;
  left: 0;
  top: 0;

  .van-loading {
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -10%);
    text-align: center;
  }
}

.group-video {
  border: 1px dashed #afafaf;
  border-radius: 10px;
  height: 37vw;
  width: 37vw;
  margin-top: 20px;
  position: relative;

  .group-video-load {
    position: relative;
    border-radius: 10px;
    height: 100%;
    width: 100%;
    border: 1px dashed #e9e9e9;
    overflow: hidden;

    .avatar-uploader {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .el-upload {
        width: 100%;
        height: 100%;

        .avatar {
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .group-load-item {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      padding: 70px 0;
      text-align: center;
      width: 100%;
      height: 100%;
      font-size: 28px;

      .video-icon-img {
        width: 80px;
        height: 50px;
        margin: 0 auto;
        font-size: 60px;
        color: #ababab;

        img {
          width: 80px;
          height: 50px;
        }
      }

      .video-icon-txt {
        color: #ababab;
        padding-top: 20px;
      }
    }

    .aod {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 10000;
      color: #fff;
      font-size: 30px;
      height: 44px;
      line-height: 44px;
      width: 44px;
      text-align: center;
      background: #222;
      border-radius: 0 12px 0 0.32rem;
    }
  }
}
</style>